import { useWsmDealerGroupCreateMutation } from "@dashboard/graphql";
import useNavigator from "@dashboard/hooks/useNavigator";
import useNotifier from "@dashboard/hooks/useNotifier";
import { commonMessages } from "@dashboard/intl";
import { getMutationState } from "@dashboard/misc";
import React from "react";
import { useIntl } from "react-intl";

import WsmDealerGroupDetailsPage from "../components/WsmDealerGroupDetailsPage/WsmDealerGroupDetailsPage";
import { sectionMessages } from "../messages";
import { wsmDealerGroupUrl } from "../urls";
import { emptyGroupFormData, getGroupCreateInput } from "../utils";

export const WsmDealerGroupCreateView = () => {
  const intl = useIntl();
  const navigate = useNavigator();
  const notify = useNotifier();
  const [createGroup, createGroupOpts] = useWsmDealerGroupCreateMutation({
    onCompleted: result => {
      const group = result.wsmDealerGroupCreate?.dealerGroup;

      if (group) {
        notify({ status: "success", text: intl.formatMessage(commonMessages.savedChanges) });
        // Prices hang off a saved group, so the merchant lands on the grid.
        navigate(wsmDealerGroupUrl(group.id));
      }
    },
  });
  const errors = createGroupOpts.data?.wsmDealerGroupCreate?.errors ?? [];

  return (
    <WsmDealerGroupDetailsPage
      title={intl.formatMessage(sectionMessages.groupCreateTitle)}
      initialData={emptyGroupFormData()}
      errors={errors}
      tierRowErrors={{}}
      disabled={createGroupOpts.loading}
      saveButtonBarState={getMutationState(
        createGroupOpts.called,
        createGroupOpts.loading,
        errors,
      )}
      currencyCode={null}
      truncatedAt={null}
      showTierPrices={false}
      onSubmit={data => createGroup({ variables: { input: getGroupCreateInput(data) } })}
    />
  );
};

export default WsmDealerGroupCreateView;
